var _rect, _ellipse, _path, _ellipse2, _path2, _ellipse3, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 300,
    viewBox: "0 0 900 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 300,
    fill: "#BCA184"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 531.222,
    cy: 148.287,
    rx: 0.777743,
    ry: 0.780021,
    fill: "#1B1D20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M528.81 145.85C516.332 133.3 459.25 76.0515 450.162 66.9717",
    stroke: "#1B1D20",
    strokeWidth: 0.89,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.78 3.78"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 449.009,
    cy: 65.78,
    rx: 0.777743,
    ry: 0.780021,
    fill: "#1B1D20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M446.597 68.1982L367.949 147.077",
    stroke: "#1B1D20",
    strokeWidth: 0.89,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.78 3.78"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.778,
    cy: 148.252,
    rx: 0.777743,
    ry: 0.780021,
    fill: "#1B1D20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M366.778 148.287L449.009 235.79L531.24 148.287L449.009 226.762L366.778 148.287Z",
    fill: "#1B1D20",
    stroke: "#1B1D20",
    strokeWidth: 1.59,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M447.279 143.168H460.631C462.379 138.611 459.722 133.492 455.668 131.196C447.313 126.113 436.145 132.598 434.24 141.713C430.046 160.206 451.316 172.616 466.748 163.677C480.328 156.665 484.086 138.365 476.623 125.482C457.765 95.9989 415.12 111.459 414.124 145.079C413.233 164.045 427.914 181.661 446.282 185.394C480.59 192.406 508.327 158.541 497.963 125.797C484.103 82.6772 426.69 78.4703 403.236 115.736C384.605 145.096 397.153 184.886 428.106 199.785C442.123 206.547 458.149 207.828 473.058 203.379C487.913 199.049 481.01 197.594 481.01 197.594",
    stroke: "#1B1D20",
    strokeWidth: 1.19,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.35b139bff281146913cb101b8f8d3c1c.svg";
export { ForwardRef as ReactComponent };